'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwitherDescription = undefined;

var _SwitcherDescription = require('./SwitherDescription/SwitcherDescription');

var _SwitcherDescription2 = _interopRequireDefault(_SwitcherDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SwitherDescription = _SwitcherDescription2.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/SHARE/index.js
// module id = 93
// module chunks = 0